<template>
  <v-app ref="app" class="transparent">
    <Header />
    <Navigation />
    <v-main>
      <v-progress-linear indeterminate
                         color="green darken-2"
                         style="z-index: 512"
                         fixed
                         v-if="false"
      />
      <v-card :dark="dark" :color="color" tile height="100%" class="d-flex flex-column">
        <RouterView />
        <PoweredBy class="flex-grow-0" />
      </v-card>
    </v-main>
    <Footer />
    <Dialogs />
  </v-app>
</template>

<script>
import Footer from '@/components/Footer';
import Dialogs from '@/components/Dialogs';
import Header from '@/components/Header';
import Navigation from '@/components/Navigation';
import PoweredBy from '@/components/PoweredBy';

export default {
  name: 'Store',
  components: { PoweredBy, Navigation, Dialogs, Footer, Header },
  data: () => ({
    loading: true
  }),
  computed: {
    dark() { return this.$store.state.theme.mainDark; },
    color() { return this.$store.state.theme.mainColor; },
    route() { return this.$route.name; },
  },
  watch: {
    route() {
      if (this.$refs && this.$refs.app && this.$refs.app.$el) {
        this.$vuetify.goTo(this.$refs.app.$el, { duration: 100 });
      }
      this.checkRoute();
    }
  },
  mounted() {
    this.checkAlcohol();
    this.checkRoute();
  },
  methods: {
    checkRoute() {
      if (!this.route) {
        const { readonly, first_page } = this.$store.state.data.settings;
        if (readonly || first_page === 'showcase') {
          this.$router.push('showcase');
        } else {
          this.$router.push('address');
        }
      }
      if (this.route === 'checkout') {
        if (this.$store.state.data.point === null) {
          this.$router.push('showcase');
        }
      }
    },
    hasAlcohol() {
      const { products } = this.$store.state.data;
      const indices = Object.keys(products);
      for (let i = 0; i < indices.length; i++) {
        const { is_alcohol } = products[indices[i]];
        if (is_alcohol) return true;
      }
      return false;
    },
    checkAlcohol() {
      const { alert_alco_disable } = this.$store.state.data.settings;
      if (!alert_alco_disable && this.hasAlcohol() && this.$route.name !== 'order') {
        this.$store.commit('ui/dialog', { name: 'AreYouLegal' });
      }
    }
  }
};
</script>
